<template>
    <MainWrapper>
        <!--div class="companies-control-panel mb-30">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="companies-control-panel-inner">
                            <router-link to="/user/settings" class="mr-20">
                                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'arrow-circle-left']" />
                                <span class="dark-body-text panel-body-text">Вернуться к профилю</span>
                            </router-link>
                            <div class="pointer pull-right">
                                <router-link :to="`/masters/${$store.state.profile.specialist_slug}`" class="mr-20">
                                    <span class="dark-body-text panel-body-text">{{ specInfo.full_name }}</span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div-->
        <div class="single-master-page">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="white-panel pt-20 pb-20 pr-20 pl-20 mb-30" v-for="(w, i) in weeks" :key="i">
                            <div class="settings-day" v-for="(d, k) in w" :key="k">
                                <div class="mb-15 flexit">
                                    <div class="checkbox mr-10" :class="{ pressed: d.checked }" @click="d.checked = !d.checked">
                                        <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                                    </div>
                                    <span class="dark-body-text">{{ d.day }}</span>
                                </div>
                                <div v-if="d.checked" class="flexit-start mb-15">
                                    <div class="mr-30 inline-block">
                                        <span class="block mb-10">Время работы</span>
                                        <div>
                                            <vue-timepicker :format="'HH:mm'" v-model="d.time.start_time" class="rounded-input mr-15"></vue-timepicker>
                                            <vue-timepicker :format="'HH:mm'" v-model="d.time.end_time" class="rounded-input"></vue-timepicker>
                                        </div>
                                    </div>
                                    <!--div class="mr-30 inline-block">
                                        <span class="block mb-20">Живая очередь</span>
                                        <div class="checkbox inline-block" :class="{ pressed: d.live_record }" @click="d.live_record = !d.live_record">
                                            <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                                        </div>
                                    </div-->
                                    <div class="inline-block">
                                        <span class="block mb-10">Обеденный перерыв</span>
                                        <div class="flexit">
                                            <div class="checkbox mr-15 inline-block" :class="{ pressed: d.lunch }" @click="d.lunch = !d.lunch">
                                                <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                                            </div>
                                            <vue-timepicker :format="'HH:mm'" v-model="d.lunch_settings.start_time" class="rounded-input mr-10"></vue-timepicker>
                                            <vue-timepicker :format="'HH:mm'" v-model="d.lunch_settings.end_time" class="rounded-input"></vue-timepicker>
                                        </div>
                                    </div>
                                </div>
                                <div class="gray-line mb-15" v-if="k !== 6"></div>
                            </div>
                            <Button v-if="action === 'create'" text="Сохранить" @click="setSchedule" class="mt-40" type="blue" />
                            <Button v-if="action === 'update'" text="Обновить" @click="updateSchedule" class="mt-40" type="blue" />
                        </div>
                        <p v-if="weeks.length == 0" class="dark-body-text mb-10">Добавить неделю</p>
                        <p v-if="weeks.length == 0" class="mb-20 gray-body-text">Вы можете кастомизировать ваше расписание на две и более недели<br /> с разным режимом работы.</p>
                        <Button v-if="weeks.length == 0" text="Добавить неделю" @click="weeks.push(week)" />
                    </div>
                </div>
            </div>
        </div>
    </MainWrapper>
</template>
<style lang="stylus" scoped>
    /* @import '../styles/main.core.vars.styl'; */

    .spec-categories
        padding: 20px 60px 30px 20px

    .flexit
        display: flex
        align-items: center

    .flexit-start
        display: flex
        align-items: flex-start

    .time-picker
        width: 107px

    .spec-categories-header
        display: flex
        .spec-count
            margin: 0 0 0 auto
            color: $gray_text

    .spec-categories-single
        display: flex
        align-items: center
        >.icon
            margin-left: auto
            font-size: 16px

    .companies-control-panel
        margin-top: -30px
        height: 56px
        background: $black_text
        .panel-body-text, .panel-icon
            color: #fff
        .panel-icon
            font-size: 16px
        &-inner
            height: 56px
            display: flex
            align-items: center
            >div
                display: flex
                align-items: center
        input
            width: 430px

    .col-lg-1
        min-height: 0

    .arr-down
        position: absolute
        bottom: -2px
        width: 0
        height: 0
        border-left: 9px solid transparent
        border-right: 9px solid transparent
        border-bottom: 9px solid $black_text
        z-index: 4
        left: 0
        right: 0
        margin: auto

    .pull-right
        margin-left: auto

    .schedule-controls
        display: flex
        align-items: center

</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Specialist from '@/components/Specialist.vue';
    import Paginator from '@/components/Paginator.vue';
    import Schedule from '@/components/Schedule.vue';
    import VueTimepicker from 'vue2-timepicker';
    import moment from 'moment';
    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            Specialist,
            Paginator,
            Schedule,
            VueTimepicker
        }
    })
    export default class CompanyAdmin extends Vue {

        moment = moment;

        specInfo = {
            rating: 0,
            categories: [],
        };

        action = 'create';
        specialist_slug = '';
        weeks = [];
        schedule_start_date = '';
        schedule_id = 0;
        schedule_company_name = '';

        week = [{
            day: 'Понедельник',
            week_day: 'monday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time: {HH: null, mm: null},
                start_time: {HH: null, mm: null}
            },
            lunch_settings: {
                end_time: {HH: null, mm: null},
                start_time: {HH: null, mm: null},
            }
        },{
            day: 'Вторник',
            week_day: 'tuesday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time: {HH: null, mm: null},
                start_time: {HH: null, mm: null}
            },
            lunch_settings: {
                end_time: {HH: null, mm: null},
                start_time: {HH: null, mm: null},
            }
        },{
            day: 'Среда',
            week_day: 'wednesday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time: {HH: null, mm: null},
                start_time: {HH: null, mm: null}
            },
            lunch_settings: {
                end_time: {HH: null, mm: null},
                start_time: {HH: null, mm: null},
            }
        },{
            day: 'Четверг',
            week_day: 'thursday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time: {HH: null, mm: null},
                start_time:  {HH: null, mm: null}
            },
            lunch_settings: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null},
            }
        },{
            day: 'Пятница',
            week_day: 'friday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null}
            },
            lunch_settings: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null},
            }
        },{
            day: 'Суббота',
            week_day: 'saturday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null}
            },
            lunch_settings: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null},
            }
        },{
            day: 'Воскресенье',
            week_day: 'sunday',
            checked: false,
            live_record: false,
            lunch: false,
            time: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null}
            },
            lunch_settings: {
                end_time:  {HH: null, mm: null},
                start_time:  {HH: null, mm: null},
            }
        },]

        nextWeek() {
            this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
                .add(7, "d")
                .format("DD.MM.YYYY");
        }

        prevWeek() {
            this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
                .subtract(7, "d")
                .format("DD.MM.YYYY");
        }

        firstDay = moment().format("DD.MM.YYYY");

        getSpecInfo() {
            http(`masters/${this.specialist_slug}`, "get", false, {}).then(r => {
                this.specInfo = r.data;
            });
        }

        getUserInfo() {
            http('user/info', 'get', this.$store.state.token, {}).then(r => {
                this.specialist_slug = r.data.specialist_slug;
                this.getSpecInfo();
            })
        }

        setSchedule() {
            let error = false;
            const data = [];
            this.weeks.map(w => {
                w.map(d => {
                    if (d.checked) {
                        const day = {};
                        if (((d.time.start_time['HH'] === null || d.time.start_time['HH'] === '') || (d.time.start_time['mm'] === null || d.time.start_time['mm'] === '')) ||
                            ((d.time.end_time['HH'] === null || d.time.end_time['HH'] === '') || (d.time.end_time['mm'] === null || d.time.end_time['mm'] === ''))) {
                            error = true;
                            return false;
                        } else {
                            day.time = {
                                start_time: `${d.time.start_time['HH']}:${d.time.start_time['mm']}`,
                                end_time: `${d.time.end_time['HH']}:${d.time.end_time['mm']}`,
                            }
                        }
                        if (d.lunch) {
                            if (((d.lunch_settings.start_time['HH'] === null || d.lunch_settings.start_time['HH'] === '') || (d.lunch_settings.start_time['mm'] === null || d.lunch_settings.start_time['mm'] === '')) ||
                                ((d.lunch_settings.end_time['HH'] === null || d.lunch_settings.end_time['HH'] === '') || (d.lunch_settings.end_time['mm'] === null || d.lunch_settings.end_time['mm'] === ''))) {
                                error = true;
                                return false;
                            } else {
                                day.lunch_settings = {
                                    start_time: `${d.lunch_settings.start_time['HH']}:${d.lunch_settings.start_time['mm']}`,
                                    end_time: `${d.lunch_settings.end_time['HH']}:${d.lunch_settings.end_time['mm']}`,
                                }
                            }
                        }
                        day.live_record = d.live_record;
                        day.week_day = d.week_day;
                        data.push(day);
                    }
                })
            });

            if (error === true) {
                this.$store.commit('notificate', { text: 'schedule error', type: 'error' });
                return false;
            }

            let url = 'companies/'+this.$route.params.slug+'/schedule/create';
            http(url, 'post', this.$store.state.token, {
                times: data,
                owner: this.$route.params.slug
            }).then(r => {
                this.$store.commit('notificate', { type: 'action', text: 'Расписание сохранено.' });
            }, err => {
                this.$store.commit('notificate', { type: 'alert', text: 'Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз.' });
            })
        }

        getSchedule() {
            let url = 'companies/'+this.$route.params.slug+'/schedule';
            http(url, 'get', false, {}).then(r => {
                if (r.data.length > 0) {
                    this.schedule_id = r.data[0].id;
                    this.schedule_start_date = r.data[0].start_date;
                    this.schedule_company_name = r.data[0].company_name;
                    let pattern = [{
                        day: 'Понедельник',
                        week_day: 'monday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time: {HH: null, mm: null},
                            start_time: {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time: {HH: null, mm: null},
                            start_time: {HH: null, mm: null},
                        }
                    },{
                        day: 'Вторник',
                        week_day: 'tuesday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time: {HH: null, mm: null},
                            start_time: {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time: {HH: null, mm: null},
                            start_time: {HH: null, mm: null},
                        }
                    },{
                        day: 'Среда',
                        week_day: 'wednesday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time: {HH: null, mm: null},
                            start_time: {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time: {HH: null, mm: null},
                            start_time: {HH: null, mm: null},
                        }
                    },{
                        day: 'Четверг',
                        week_day: 'thursday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time: {HH: null, mm: null},
                            start_time:  {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null},
                        }
                    },{
                        day: 'Пятница',
                        week_day: 'friday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null},
                        }
                    },{
                        day: 'Суббота',
                        week_day: 'saturday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null},
                        }
                    },{
                        day: 'Воскресенье',
                        week_day: 'sunday',
                        checked: false,
                        live_record: false,
                        lunch: false,
                        time: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null}
                        },
                        lunch_settings: {
                            end_time:  {HH: null, mm: null},
                            start_time:  {HH: null, mm: null},
                        }
                    }];
                    moment.lang('ru');
                    let k = -1;
                    r.data.forEach(function (elm) {
                        elm.times.forEach(function (el) {
                            if (el.week_day === 'monday') { k = 0; }
                            if (el.week_day === 'tuesday') { k = 1; }
                            if (el.week_day === 'wednesday') { k = 2; }
                            if (el.week_day === 'thursday') { k = 3; }
                            if (el.week_day === 'friday') { k = 4; }
                            if (el.week_day === 'saturday') { k = 5; }
                            if (el.week_day === 'sunday') { k = 6; }
                            pattern[k].checked = true;
                            pattern[k].live_record = el.live_record;
                            pattern[k].time.start_time = {HH: moment(el.time.start_time, 'HH:mm:ss').format('HH'), mm: moment(el.time.start_time, 'HH:mm:ss').format('mm')};
                            pattern[k].time.end_time = {HH: moment(el.time.end_time, 'HH:mm:ss').format('HH'), mm: moment(el.time.end_time, 'HH:mm:ss').format('mm')};
                            if (el.lunch_settings) {
                                pattern[k].lunch = true;
                                pattern[k].lunch_settings.start_time = {
                                    HH: moment(el.lunch_settings.start_time, 'HH:mm:ss').format('HH'),
                                    mm: moment(el.lunch_settings.start_time, 'HH:mm:ss').format('mm')
                                };
                                pattern[k].lunch_settings.end_time = {
                                    HH: moment(el.lunch_settings.end_time, 'HH:mm:ss').format('HH'),
                                    mm: moment(el.lunch_settings.end_time, 'HH:mm:ss').format('mm')
                                };
                            } else {
                                pattern[k].lunch = false;
                            }
                        });
                    });
                    this.weeks.push(pattern);
                    this.action = 'update';
                }
            }, err => {
                this.$store.commit('notificate', { type: 'alert', text: 'Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз.' });
            })
        }

        updateSchedule() {
            let error = false;
            const data = [];
            this.weeks.map(w => {
                w.map(d => {
                    if (d.checked) {
                        const day = {};
                        if (((d.time.start_time['HH'] === null || d.time.start_time['HH'] === '') || (d.time.start_time['mm'] === null || d.time.start_time['mm'] === '')) ||
                            ((d.time.end_time['HH'] === null || d.time.end_time['HH'] === '') || (d.time.end_time['mm'] === null || d.time.end_time['mm'] === ''))) {
                            error = true;
                            return false;
                        } else {
                            day.time = {
                                start_time: `${d.time.start_time['HH']}:${d.time.start_time['mm']}`,
                                end_time: `${d.time.end_time['HH']}:${d.time.end_time['mm']}`,
                            }
                        }
                        if (d.lunch) {
                            if (((d.lunch_settings.start_time['HH'] === null || d.lunch_settings.start_time['HH'] === '') || (d.lunch_settings.start_time['mm'] === null || d.lunch_settings.start_time['mm'] === '')) ||
                                ((d.lunch_settings.end_time['HH'] === null || d.lunch_settings.end_time['HH'] === '') || (d.lunch_settings.end_time['mm'] === null || d.lunch_settings.end_time['mm'] === ''))) {
                                error = true;
                                return false;
                            } else {
                                day.lunch_settings = {
                                    start_time: `${d.lunch_settings.start_time['HH']}:${d.lunch_settings.start_time['mm']}`,
                                    end_time: `${d.lunch_settings.end_time['HH']}:${d.lunch_settings.end_time['mm']}`,
                                }
                            }
                        }
                        day.live_record = d.live_record;
                        day.week_day = d.week_day;
                        data.push(day);
                    }
                })
            });

            if (error === true) {
                this.$store.commit('notificate', { text: 'schedule error', type: 'error' });
                return false;
            }

            let url = 'companies/'+this.$route.params.slug+'/schedule/update';
            http(url, 'post', this.$store.state.token, {
                id: this.schedule_id,
                times: data,
                start_date: this.schedule_start_date,
                company_name: this.schedule_company_name
            }).then(r => {
                this.$store.commit('notificate', { type: 'action', text: 'Расписание сохранено.' });
            }, err => {
                this.$store.commit('notificate', { type: 'alert', text: 'Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз.' });
            })
        }

        created() {
            //this.getUserInfo();
            this.getSchedule();
        }


    }
</script>